import { Button, Col, Divider, Form, Input, message, Row } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React from 'react';
import InputMask from '../../components/input-mask';
import { prefijos3Digitos } from '../../utils';

const PasajerosList = ({ onBack, onNext, emergencia }) => {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    if (onNext) {
      onNext(values);
    }
  };

  const onFinishFailed = () => {
    message.warning('Completá todos los campos requeridos.');
  };

  const goBack = () => {
    const { getFieldsValue } = form;
    if (onBack) {
      onBack(getFieldsValue());
    }
  };

  return (
    <>
      <Form
        name="Emergencia"
        initialValues={emergencia}
        scrollToFirstError
        onFinish={onFinish}
        onFinishFailed={() => onFinishFailed()}
        form={form}
        layout="vertical"
        autoComplete="off"
      >
        <Divider>Confirme Datos del Contacto de Emergencia</Divider>
        <Row
          gutter={[16, 24]}
          style={{
            maxWidth: '1200px',
            marginTop: 'auto',
            marginBottom: 'auto',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        >
          <Col xs={24} md={12} align="start">
            <Form.Item
              label="Nombre Contacto"
              name="nombres"
              rules={[{ required: true }]}
            >
              <Input placeholder="Ingrese un valor" />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} align="start">
            <Form.Item
              label="Celular"
              name="celular"
              rules={[
                { required: true, message: 'Requerido' },
                {
                  pattern: `^\\((${prefijos3Digitos.join(
                    '|'
                  )})\\) [0-9]{3}-[0-9]{3}$`,
                  message: 'Número no válido'
                }
              ]}
            >
              <InputMask
                mask="(999) 999-999"
                placeholder="(___) ___-___"
                addonBefore="+595"
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} align="start">
            <Form.Item
              label="Correo"
              name="correo"
              rules={[
                {
                  type: 'email',
                  message: 'El correo no es válido',
                  required: true
                }
              ]}
            >
              <Input placeholder="Ingrese un valor" type="email" />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} align="start">
            <Form.Item label="Consideraciones Contacto" name="consideraciones">
              <TextArea
                placeholder="Ingrese un valor"
                autoSize={{ minRows: 1 }}
              />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Button style={{ margin: 10 }} onClick={goBack}>
            Anterior
          </Button>
          <Button style={{ margin: 10 }} type="primary" htmlType="submit">
            Siguiente
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default PasajerosList;
